import { FC } from 'react';
import { Tooltip } from 'antd';
import { ContentIcon, ContentText, ContentWrapper, TooltipText } from './TrendAnimation.style';
interface Props {
  text: string;
  icon: string;
  color: string;
  tooltipText: string;
  slugUrl: string;
  isHover: boolean;
  contentIndex: number;
  setHoverIndex: (val: number) => void;
  onClick: () => void;
}
const Content: FC<Props> = ({
  text,
  icon,
  color,
  tooltipText,
  slugUrl,
  isHover,
  contentIndex,
  setHoverIndex,
  onClick
}: Props) => {
  return tooltipText ? <ContentWrapper onMouseOver={() => setHoverIndex(contentIndex)} onClick={onClick}>
            <ContentIcon src={icon} alt="icon" width={72} height={72} />
            <Tooltip title={<TooltipText>{tooltipText}</TooltipText>} color="#ffffff" open={isHover}>
                <ContentText $color={color} $isHover={isHover}>
                    {text}
                </ContentText>
            </Tooltip>
        </ContentWrapper> : <ContentWrapper onMouseOver={() => setHoverIndex(contentIndex)}>
            <ContentIcon src={icon} alt="icon" />
            <ContentText $color={color} $isHover={isHover}>
                {text}
            </ContentText>
        </ContentWrapper>;
  // return (
  //     <Tooltip
  //         title={<TooltipText>{tooltipText}</TooltipText>}
  //         color="#ffffff"
  //         open={isHover}
  //     >
  //         <Link href={slugUrl}>
  //             <ContentWrapper onMouseOver={() => setHoverIndex(contentIndex)}>
  //                 <ContentIcon src={icon} alt="icon" />
  //                 <ContentText $color={color} $isHover={isHover}>
  //                     {text}
  //                 </ContentText>
  //             </ContentWrapper>
  //         </Link>
  //     </Tooltip>
  // )
};
export default Content;